export const DEFAULT_DOC_CHAT_ACTIONS: string[] = [
  'Summarize the document',
  'Provide main takeaways',
];
